import api from 'services/api';

/**
 * Saldo dos almoxarifados de backup de infraestrutura.
 *
 * Única leitura de Estoque sem fluxo legado no backend: não existe workflow n8n equivalente. Por
 * isso o serviço distingue os códigos de erro em vez de devolver lista vazia em qualquer falha —
 * "não liberado", "IXC fora do ar" e "depósito vazio" são três coisas diferentes, e só a terceira
 * é uma resposta sobre estoque.
 */

export const BACKUP_INFRA_ERROS = {
  IXC_DIRECT_DISABLED: 'A leitura direta do estoque de backup ainda não foi liberada para esta empresa.',
  IXC_UNAVAILABLE: 'O IXC não respondeu. O saldo mostrado pode estar desatualizado ou ausente.',
  EMPRESA_INDEFINIDA: 'Selecione uma única empresa: saldo de almoxarifado não se soma entre bases diferentes.',
};

export class BackupInfraService {
  constructor(rota = 'backup-infra', chave = 'backup_infra', erros = BACKUP_INFRA_ERROS) {
    this.rota = rota;
    this.chave = chave;
    this.erros = erros;
  }

  /**
   * Não recebe período: saldo é retrato do agora.
   *
   * @returns {Promise<Array>} uma linha por produto e almoxarifado.
   */
  async buscarSaldos() {
    const response = await api.post(`/n8n/estoque/${this.rota}`, {});

    return response.data?.data?.[this.chave] ?? [];
  }

  /**
   * Traduz o erro do backend para uma frase que diz o que aconteceu. Sem isso, os três desfechos
   * viram "Erro ao carregar dados" e o operador não sabe se falta liberar acesso ou se o depósito
   * está mesmo vazio.
   */
  mensagemDeErro(error) {
    const codigo = error?.response?.data?.code;

    return this.erros[codigo]
      || error?.response?.data?.message
      || error?.message
      || 'Erro ao carregar os saldos.';
  }
}

const backupInfraService = new BackupInfraService();

export default backupInfraService;
